<script setup lang="ts">
import TextHeadline from '~/components/foundations/TextHeadline.vue'

export type Key =
  | '1'
  | '2'
  | '3'
  | '4'
  | '5'
  | '6'
  | '7'
  | '8'
  | '9'
  | '0'
  | '-'
  | '.'
  | 'backspace'

const props = defineProps<{ value: Key }>()

const emits = defineEmits<{
  (e: 'keyPress', value: Key): void
}>()
</script>

<template>
  <button class="numeric-keyboard-key" @click="emits('keyPress', props.value)">
    <TextHeadline size="small">{{ props.value }}</TextHeadline>
  </button>
</template>

<style lang="scss" scoped>
.numeric-keyboard-key {
  background-color: var(--semantic-tokens-neutral-xweak-surface);
  border: none;
  border-radius: 4px;
  height: 48px;

  &:hover {
    background-color: var(--semantic-tokens-neutral-weak-surface);
  }
}
</style>
